export function getMode() {
  return sessionStorage.getItem('view-mode') || '0';
}

export function setMode(mode) {
  sessionStorage.setItem('view-mode', mode);
}

export function toggleMode() {
  const currentMode = getMode();
  setMode(currentMode === '1' ? '0' : '1');
}
